<template>
  <main id="userApply" v-if="config.status.authed">
    <Toolbar ref="toolbar" :item="getItem" @select="update" />
    <v-progress-linear v-if="isInitializaing" class="ma-0" indeterminate color="blue"></v-progress-linear>
    <v-container fluid grid-list-md class="pa-0" v-if="!isInitializaing">
      <v-layout v-if="isSetItem" row wrap>
        <v-flex xs12 v-if="isItemSuspended">
          <p class="body-1 red--text">この申込は現在、担当者が確認中です。</p>
        </v-flex>
        <v-flex xs12 md4>
          <v-card>
            <v-list class="pa-0">
              <v-list-tile class="grey lighten-4 grey--text text--darken-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fas', 'school']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold">コース</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="!isItemPublished && !isItemSuspended">
                  <v-menu bottom left offset-y>
                    <v-btn icon slot="activator" color="blue--text text--darken-2" :loading="isLoading"><font-awesome-icon :icon="['fas', 'bars']" size="lg"></font-awesome-icon></v-btn>
                    <v-list>
                      <v-list-tile @click="edit({ type: 'course' })">
                        <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>新規追加する</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <template v-for="(item, idx) in getCourseItems">
                <v-list-tile :key="item.id" class="my-3">
                  <v-list-tile-content>
                    <v-list-tile-sub-title class="caption"><span class="font-weight-bold">レッスン内容：</span>{{ item.lesson.size + item.lesson.unit }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    <v-list-tile-sub-title class="caption">
                      <span class="font-weight-bold">期間：</span>
                      <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                      <span v-if="item.term && item.term.size || item.extra && item.extra.size">
                        {{
                          [
                            '（',
                            [
                              (item.term && item.term.size) ? (item.term.size + item.term.unit) : null,
                              (item.extra && item.extra.size) ? (item.extra.size + item.extra.unit) : null
                            ].filter(it => { return it }).join('+'),
                            '）'
                          ].join('').replace('（）', '')
                        }}
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-list-tile-action v-if="!isItemPublished && !isItemSuspended">
                    <v-menu bottom left offset-y>
                      <v-btn icon slot="activator" color="blue--text text--darken-2" :loading="isLoading"><v-icon>more_vert</v-icon></v-btn>
                      <v-list>
                        <v-list-tile @click="edit({ type: 'course', data: item })">
                          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>編集する</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="remove({ type: 'courses', data: item })">
                          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon></v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>削除する</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action> -->
                </v-list-tile>
                <v-divider v-if="(idx + 1) !== getCourseItems.length" :key="`${item.id}_div`"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 md4>
          <v-card>
            <v-list class="pa-0">
              <v-list-tile class="grey lighten-4 grey--text text--darken-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold">滞在</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="!isItemPublished && !isItemSuspended">
                  <v-menu bottom left offset-y>
                    <v-btn icon slot="activator" color="blue--text text--darken-2" :loading="isLoading"><font-awesome-icon :icon="['fas', 'bars']" size="lg"></font-awesome-icon></v-btn>
                    <v-list>
                      <v-list-tile @click="edit({ type: 'stay' })">
                        <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>新規追加する</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <template v-for="(item, idx) in getStayItems">
                <v-list-tile :key="item.id" class="my-3">
                  <v-list-tile-content>
                    <v-list-tile-sub-title class="caption"><span class="font-weight-bold">宿泊タイプ：</span>{{ item.type }}</v-list-tile-sub-title>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    <v-list-tile-sub-title class="caption">
                      <span class="font-weight-bold">期間：</span>
                      <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                      <span v-if="item.term && item.term.size || item.extra && item.extra.size">
                        {{
                          [
                            '（',
                            [
                              (item.term && item.term.size) ? (item.term.size + item.term.unit) : null,
                              (item.extra && item.extra.size) ? (item.extra.size + item.extra.unit) : null
                            ].filter(it => { return it }).join('+'),
                            '）'
                          ].join('').replace('（）', '')
                        }}
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- <v-list-tile-action v-if="!isItemPublished && !isItemSuspended">
                    <v-menu bottom left offset-y>
                      <v-btn icon slot="activator" color="blue--text text--darken-2" :loading="isLoading"><v-icon>more_vert</v-icon></v-btn>
                      <v-list>
                        <v-list-tile @click="edit({ type: 'stay', data: item })">
                          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>編集する</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="remove({ type: 'stays', data: item })">
                          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon></v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>削除する</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action> -->
                </v-list-tile>
                <v-divider v-if="(idx + 1) !== getStayItems.length" :key="`${item.id}_div`"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 md4>
          <v-card>
            <v-list class="pa-0">
              <v-list-tile class="grey lighten-4 grey--text text--darken-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fas', 'clipboard-list']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="font-weight-bold">委託手配</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="!isItemPublished && !isItemSuspended">
                  <v-menu bottom left offset-y>
                    <v-btn icon slot="activator" color="blue--text text--darken-2" :loading="isLoading"><font-awesome-icon :icon="['fas', 'bars']" size="lg"></font-awesome-icon></v-btn>
                    <v-list>
                      <v-list-tile @click="edit({ type: 'arrangements', data: store.item ? store.item.arrangements : {} })">
                        <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>編集する</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <v-list-tile class="my-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plane']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title v-if="!isFlightEmpty" class="caption">航空手配</v-list-tile-sub-title>
                  <v-list-tile-title>{{ printFlight }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="my-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'first-aid']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title v-if="!isInsuranceEmpty" class="caption">保険手配</v-list-tile-sub-title>
                  <v-list-tile-title>{{ printInsurance }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="my-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'id-card']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title v-if="!isVisaEmpty" class="caption">査証手配</v-list-tile-sub-title>
                  <v-list-tile-title>{{ printVisa }}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="!isVisaEmpty" class="caption">
                    <span class="font-weight-bold">種類：</span>{{ printVisaType }}
                    <span class="font-weight-bold">{{ printVisaLocal }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="my-3">
                <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'car-side']"></font-awesome-icon></v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-sub-title v-if="!isPickupEmpty" class="caption">送迎手配</v-list-tile-sub-title>
                  <v-list-tile-title>{{ printPickup }}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="printPickupName || printPickupType" class="caption">
                    <span class="font-weight-bold" v-if="printPickupName">送迎者：</span>{{ printPickupName }}
                    <span class="font-weight-bold">{{ printPickupType }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <p class="headline text-xs-center grey--text">申し込みがございません。"編集する"ボタンより申し込みを追加してください。</p>
        </v-flex>
      </v-layout>
      <CourseModal ref="course" @done="edited"></CourseModal>
      <StayModal ref="stay" @done="edited"></StayModal>
      <ArrangementsModal ref="arrangements" @done="edited"></ArrangementsModal>
    </v-container>
    <Footer :item="getItem" @emit="emitted" />
  </main>
</template>

<script>
import Toolbar from './toolbar'
import Footer from './footer'
import CourseModal from './modals/course'
import StayModal from './modals/stay'
import ArrangementsModal from './modals/arrangements'
export default {
  name: 'userApply',
  components: {
    Toolbar,
    Footer,
    CourseModal,
    StayModal,
    ArrangementsModal
  },
  data () {
    return {
      config: {
        status: {
          loading: true,
          authed: true
        }
      },
      meta: {
      },
      store: {
        item: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
    },
    emitted: function (req) {
      console.log('emitted')
      console.log(req)
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    get: function (item) {
      if (item && item.id) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/apply/get/item', {
          id: item.id
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            this.$set(this.store, 'item', Object.assign({
              id: item.id,
              title: item.title || '',
              type: item.type || '',
              country: item.country || '',
              city: item.city || '',
              published_at: item.published_at || '',
              modified_at: item.modified_at || '',
              status: item.status || ''
            }, res.data.data))
          }
        })
      }
    },
    update: function (item) {
      if (item && item.id) {
        this.get(item)
      } else {
        this.$set(this.store, 'item', {})
      }
    },
    updateItems: function (item) {
      if (this.$refs.toolbar && item) {
        this.$refs.toolbar.insert(item)
      }
    },
    edit: function (req) {
      if (
        req &&
        req.type &&
        this.$refs[req.type]
      ) {
        this.$refs[req.type].open((req.data && req.data.id) ? req.data : null)
      }
    },
    edited: function (req) {
      if (
        req.type &&
        req.data &&
        this.store.item &&
        this.store.item.id
      ) {
        let fm = req.data
        let action = (fm.id && Number.isFinite(fm.id)) ? 'update' : 'insert'
        let type = req.type === 'courses' ? 'course' : (req.type === 'stays' ? 'stay' : req.type)
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/apply/' + action + '/meta', {
          id: fm.id,
          cid: this.store.item.id,
          type: type,
          form: fm
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            if (action === 'update') {
              if (type === 'course') {
                let idx = this.store.item.courses.findIndex(it => {
                  return it.id === fm.id
                })
                if (idx >= 0) {
                  this.store.item.courses.splice(idx, 1, fm)
                }
              } else if (type === 'stay') {
                let idx = this.store.item.stays.findIndex(it => {
                  return it.id === fm.id
                })
                if (idx >= 0) {
                  this.store.item.stays.splice(idx, 1, fm)
                }
              } else if (type === 'arrangements') {
                this.store.item.arrangements = fm
              }
            } else if (action === 'insert') {
              if (type === 'course') {
                this.store.item.courses.push(Object.assign(fm, { id: res.data.data }))
              } else if (type === 'stay') {
                this.store.item.stays.push(Object.assign(fm, { id: res.data.data }))
              } else if (type === 'arrangements') {
                this.store.item.arrangements = Object.assign(fm, { id: res.data.data })
              }
            }
          }
        })
      }
    },
    remove: function () {

    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    }
  },
  computed: {
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    isInitializaing () {
      return this.store.item == null
    },
    isLoading () {
      return this.config.status.loading
    },
    isSetItem () {
      return (this.store.item && this.store.item.id)
    },
    isItemSuspended () {
      return (this.store.item && this.store.item.status === 4)
    },
    isItemPublished () {
      return (this.store.item && this.store.item.published_at && this.store.item.published_at !== '0000-00-00 00:00:00')
    },
    printTitle () {
      return (
        this.store.item &&
        this.store.item.title
      ) ? this.store.item.title : ''
    },
    printCountry () {
      return (
        this.store.item &&
        this.store.item.country &&
        this.$meta.nations[this.store.item.country]
      ) ? this.$meta.nations[this.store.item.country] : ''
    },
    printCity () {
      return (
        this.store.item &&
        this.store.item.city
      ) ? this.store.item.city : ''
    },
    isFlightEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.flight &&
        this.store.item.arrangements.flight.status
      )
    },
    printFlight () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.flight &&
        this.store.item.arrangements.flight.status
      ) ? this.store.item.arrangements.flight.status : '航空手配'
    },
    isInsuranceEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.insurance &&
        this.store.item.arrangements.insurance.status
      )
    },
    printInsurance () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.insurance &&
        this.store.item.arrangements.insurance.status
      ) ? this.store.item.arrangements.insurance.status : '保険手配'
    },
    isVisaEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.status
      )
    },
    isVisaTypeEmpty () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.type
      )
    },
    isVisaLocalEmpty () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.local
      )
    },
    printVisa () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.status
      ) ? this.store.item.arrangements.visa.status : '査証手配'
    },
    printVisaType () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.type
      ) ? this.store.item.arrangements.visa.type : ''
    },
    printVisaLocal () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.local
      ) ? '（現地申請）' : ''
    },
    isPickupEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.status
      )
    },
    printPickup () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.status
      ) ? this.store.item.arrangements.pickup.status : '送迎手配'
    },
    printPickupName () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.name
      ) ? this.store.item.arrangements.pickup.name : ''
    },
    printPickupType () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.type
      ) ? `（${this.store.item.arrangements.pickup.type}）` : ''
    },
    printPublishedAt () {
      return (this.store.item && this.store.item.published_at) ? this.store.item.published_at : false
    },
    printModifiedAt () {
      return (this.store.item && this.store.item.modified_at) ? this.store.item.modified_at : false
    },
    getItem () {
      return this.store.item
    },
    getCourseItems () {
      return (
        this.store.item &&
        this.store.item.courses &&
        this.store.item.courses.length
      ) ? this.store.item.courses : []
    },
    getStayItems () {
      return (
        this.store.item &&
        this.store.item.stays &&
        this.store.item.stays.length
      ) ? this.store.item.stays : []
    }
  }
}
</script>

<style lang="scss">
#userApply {
}
</style>
